import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { App } from "@/app/App";
import { ComparePage } from "@/pages/compare/ComparePage";
import { ChatPage } from "@/pages/chat/ChatPage";
import { StatsPage } from "@/pages/stats/StatsPage";
import { OnboardingPage } from "@/pages/onboarding/OnboardingPage";
import { RouteErrorBoundary } from "@/ui/ErrorBoundary/ErrorBoundary";

const routes = [
  {
    element: <App />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { path: "/", element: <ComparePage /> },
      { path: "/stats", element: <StatsPage /> },
      { path: "/chat", element: <ChatPage /> },
    ],
  },
  {
    // Знакомство живёт вне оболочки: пока оно идёт, таб-бара нет.
    path: "/onboarding",
    element: <OnboardingPage />,
    errorElement: <RouteErrorBoundary />,
  },
];

// На стенде приложение живёт под подпутём (VITE_CDN_BASE=/sd-assistant/ →
// vite `base`); роутеру нужен тот же префикс, иначе `/` не совпадёт.
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

export const router = createBrowserRouter(routes, { basename });
